/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
/** Utilities */
/** Common Components */
import Image from "../../components/image/Image";
import RenderTabs from "../../components/ui/tabs/RenderTabs";
/** Common Services & Data Files */
import { AppIcons } from "../../data/appIcons";
import ToastService from "../../services/toastService/ToastService";
/** Configuration Files */
import { organizationFormData } from "./config/organization.data";
import OrganizationMailConfig from "./components/OrganizationMailConfig/OrganizationMailConfig";
/** RTK Query */
import {
  useLazyGetOrganizationByIdQuery,
  useUpdateOrganizationByIdMutation
} from "../../app/services/organizationAPI";
/** CSS Files */
import "./Organization.scss";
/** Lazily Loaded Components */
import OrganizationLocation from "./components/OrganizationLocation";
import OrganizationWorkSchedule from "./components/OrganizationWorkSchedule/OrganizationWorkSchedule";

const Organization = () => {
  /* State*/
  const [organizationForm, setOrganizationForm] = useState(organizationFormData);
  const [file] = useState([]);
  const organizationId = useSelector((state) => state.auth.user.organizationId);
  // API'S Call
  const [getOrganizationById, {
    isSuccess: organizationSuccess,
    data: organizationData
  }] = useLazyGetOrganizationByIdQuery();

  const [updateOrganizationById, {
    isSuccess: isupdateOrganizationByIdAdded,
    data: updateOrganizationByIdData
  }] = useUpdateOrganizationByIdMutation();

  //** useEffect's */
  useEffect(() => {
    if (organizationId) {
      getOrganizationById(organizationId);
    }
  }, [organizationId]);

  useEffect(() => {
    if (organizationSuccess && organizationData) {
      if (organizationData.organizationPicBase64) {
        let formData = { ...organizationForm };
        formData.initialState = {
          ...organizationForm.initialState,
          organizationLogo: `data:image/png;base64,${organizationData.organizationPicBase64}`,
          base64File: null,
        };
        setOrganizationForm(formData);
      }
    }
  }, [organizationSuccess, organizationData]);

  useEffect(() => {
    if (isupdateOrganizationByIdAdded && updateOrganizationByIdData) {
      if (updateOrganizationByIdData.errorMessage.includes("exists")) {
        ToastService.warning(updateOrganizationByIdData.errorMessage);
        return;
      } else {
        ToastService.success(updateOrganizationByIdData.errorMessage);
        getOrganizationById(organizationId);
      }
    }
  }, [isupdateOrganizationByIdAdded, updateOrganizationByIdData]);

  useEffect(() => {
    if (file.length) {
      const payload = {
        organizationLogo: file[0].fileName,
        base64File: file[0].base64Data,
        organizationId: organizationId,
      };
      updateOrganizationById(payload);
    }
  }, [file]);
  //** Funcation's */
  const tabs = [
    {
      sMenuItemCaption: "Mail Config",
      icon: "",
      component: <div className="mt-2"> <OrganizationMailConfig /></div>,
    },
    {
      sMenuItemCaption: "Settings",
      icon: "",
      component: <div className="mt-2"><OrganizationWorkSchedule /></div>,
    },
  ];

  return (
    <div className="organization-section">
      <div className="organization-header">
        <div className="organization-background"></div>
        <div className="organization-header-content">
          <div className="organization-header-fileuploader">
            {/* <Iconify icon="mingcute:building-5-line" width={50} /> */}
            <Image
              imgCustomClassName="priority-icon"
              imagePath={AppIcons.Moltechlogo}
              altText="Medium Priority"
            />
          </div>
          <div className="organization-header-text-content">
            <div className="organization-header-title">
              <div className="organization-name">
                Moltech Solutions Pvt. Ltd.
              </div>
              <div className="organization-desc">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
      <div className="row col-12">
        <div className="col-3 mt-4">
          <div className="location-section">
            <OrganizationLocation />
          </div>
        </div>
        <div className="col-9 mt-4 location-section">
          <div className="row">
            <div className="col-12 p-0">
              <div className="organization-tabs">
                <RenderTabs tabs={tabs} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Organization;
